import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null // Estado para almacenar los datos del usuario
  },
  mutations: {
    setUser(state, userData) {
      state.user = userData; // Mutación para actualizar el usuario
    }
  },
  actions: {
  },
  modules: {
  }
})
